import { Matrix3, Matrix4, Raycaster, Vector2 } from "three";



class HotspotInstance {

  constructor() {
    this.enabled = false;
    this.element = null;
    this.scene = null;
    this.intersections = null;
    this.position = null;
    this.normal = null;
  }


  async bind(element, scene, boolly) {
    this.enabled = boolly;
    this.element = element;
    this.scene = scene;

    if (boolly) {
      return this.element.addEventListener("mouseup", this.onClickScene.bind(this), false);
    } else {
      this.element.removeEventListener("mouseup", this.onClickScene);
    }
  }


  points() {
    this.boolly = false;
    return { position: this.position, normal: this.normal }
  }


  onClickScene(event) {
    const { position, normal } = this.positionAndNormalFromPoint(event.clientX, event.clientY);
    this.position = position;
    this.normal = normal;
  }

  positionAndNormalFromPoint(pixelX, pixelY) {
    let pixelPosition = new Vector2();
    const worldToModel = new Matrix4();
    const worldToModelNormal = new Matrix3();
    const { width, height, target } = this.scene;
    pixelPosition.set(pixelX / width, pixelY / height).multiplyScalar(2).subScalar(1);
    pixelPosition.y *= -1;

    const hit = this.scenePositionAndNormalFromPoint(pixelPosition);
    if (hit == null) {
      return { position: null, normal: null };
    }

    worldToModel.copy(target.matrixWorld).invert();
    const position = this.toVector3D(hit.position.applyMatrix4(worldToModel));

    //Idontknowwhy 
    position.x = (position.x - 0.15);
    worldToModelNormal.getNormalMatrix(worldToModel);
    const normal = this.toVector3D(hit.normal.applyNormalMatrix(worldToModelNormal));
    return { position: position, normal: normal };
  }

  scenePositionAndNormalFromPoint(pixelPosition) {
    const raycaster = new Raycaster();
    raycaster.setFromCamera(pixelPosition, this.element.scene().getCamera());
    const hits = raycaster.intersectObject(this.element.scene(), true);

    if (hits.length === 0)
      return null;

    const hit = hits[0];
    if (hit.face == null)
      return null;

    hit.face.normal.applyNormalMatrix(
      new Matrix3().getNormalMatrix(hit.object.matrixWorld));

    return { position: hit.point, normal: hit.face.normal };
  }

  toVector3D(v) {
    return {
      x: v.x,
      y: v.y,
      z: v.z,
      toString() {
        return `${this.x}m ${this.y}m ${this.z}m`;
      }
    };
  }


}

const HotSpotInsctance = new HotspotInstance();

//Object.freeze(HotSpotInsctance);

export default HotSpotInsctance;